// Generated by purs version 0.14.1
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Effect = require("../Effect/index.js");
var Effect_Ref = require("../Effect.Ref/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_NullOrUndefined = require("../Foreign.NullOrUndefined/index.js");
var FToken = function (x) {
    return x;
};
var Retry = (function () {
    function Retry() {

    };
    Retry.value = new Retry();
    return Retry;
})();
var Input = (function () {
    function Input(value0) {
        this.value0 = value0;
    };
    Input.create = function (value0) {
        return new Input(value0);
    };
    return Input;
})();
var someInput = new Input([ {
    value: 3,
    type: "number"
}, {
    value: 0,
    type: "ws"
}, {
    value: 0,
    type: "times"
}, {
    value: 0,
    type: "ws"
}, {
    value: 3,
    type: "number"
} ]);
var pureLexer = {
    state: {
        input: [  ],
        current: 0
    },
    setInput: function (s) {
        return function (v) {
            if (v instanceof Retry) {
                return {
                    input: s.input,
                    current: s.current - 1 | 0
                };
            };
            if (v instanceof Input) {
                return {
                    input: v.value0,
                    current: 0
                };
            };
            throw new Error("Failed pattern match at Lexer (line 66, column 22 - line 68, column 44): " + [ v.constructor.name ]);
        };
    },
    next: function (state) {
        return Control_Applicative.pure(Effect.applicativeEffect)((function () {
            var v = Data_Array.index(state.input)(state.current);
            if (v instanceof Data_Maybe.Nothing) {
                return {
                    state: state,
                    token: Data_Maybe.Nothing.value
                };
            };
            if (v instanceof Data_Maybe.Just) {
                return {
                    state: {
                        current: state.current + 1 | 0,
                        input: state.input
                    },
                    token: new Data_Maybe.Just(v.value0)
                };
            };
            throw new Error("Failed pattern match at Lexer (line 70, column 7 - line 72, column 84): " + [ v.constructor.name ]);
        })());
    },
    formatError: function (v) {
        return "error!";
    },
    has: function (v) {
        return true;
    }
};
var fromToken = function (v) {
    if (v instanceof Data_Maybe.Nothing) {
        return Foreign.unsafeToForeign(Foreign_NullOrUndefined["undefined"]);
    };
    if (v instanceof Data_Maybe.Just) {
        return Foreign.unsafeToForeign(v.value0);
    };
    throw new Error("Failed pattern match at Lexer (line 29, column 1 - line 29, column 53): " + [ v.constructor.name ]);
};
var mkLexer = function (plexer) {
    return function __do() {
        var ref = Effect_Ref["new"](plexer.state)();
        return {
            next: function __do() {
                var s = Effect_Ref.read(ref)();
                var next = plexer.next(s)();
                Effect_Ref.write(next.state)(ref)();
                return fromToken(next.token);
            },
            save: Effect_Ref.read(ref),
            reset: function (chunk, v) {
                var s = Effect_Ref.read(ref)();
                return Effect_Ref.write(plexer.setInput(s)(chunk))(ref)();
            },
            formatError: plexer.formatError,
            has: plexer.has
        };
    };
};
var lexer = mkLexer(pureLexer);
module.exports = {
    FToken: FToken,
    fromToken: fromToken,
    mkLexer: mkLexer,
    Retry: Retry,
    Input: Input,
    pureLexer: pureLexer,
    lexer: lexer,
    someInput: someInput
};
